import React, { useEffect, useMemo, useState } from 'react';
import styles from "./ScheduledTab.module.scss";
import ScheduledTabImg from "assets/png/ScheduledTab_Img.png";
import Button from 'components/shared/button/Button';
import { useNavigate } from 'react-router-dom';
import { NewTable } from 'components/shared/commonTable/Table';
import { useDispatch, useSelector } from 'react-redux';
import ProgressBar from 'components/shared/ProgressBar/ProgressBar';
import { Chip, Tooltip } from '@mui/material';
import { ReactComponent as Delete_Icon } from "assets/svg/Delete_Icon.svg"
import { clearAnnouncements, fetchannouncementList, setAnnpuncementsSchedulePagination } from '@redux/slices/announcementSlice';
import dayjs from 'dayjs';
import DeleteModal from 'components/shared/deleteModal/DeleteModal';
import { ANNOUNCEMENT } from 'services/apiEndpoints';
import { getUserAccess } from 'utils/utils';
import { permissionsDenied } from 'utils/permission';


const ScheduledTab = () => {
  const { totalCount, status, limit, pageNumber } = useSelector(
    (state) => state.announcement.announcementsSchedule
  );
  const { announcements } = useSelector(
    (state) => state.announcement
  );
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedAnnouncement, setSelectedAnnouncement] = useState({});

  const column = useMemo(() => {
    return (
      [
        {
          name: "Title",
          selector: row =>
            <Tooltip
              disableInteractive
              title={row.title}
            >
              {row.title}
            </Tooltip>
        },
        {
          name: "Sent By",
          selector: row =>
            <Tooltip
              disableInteractive
              title={`${row.createdBy?.firstName} ${row.createdBy?.lastName}`}
            >
              {`${row.createdBy?.firstName} ${row.createdBy?.lastName}`}
            </Tooltip>
        },
        {
          name: "Status",
          selector: () => <Chip
            size="small"
            sx={{
              backgroundColor: 'rgb(51, 204, 153)',
              color: 'white',
              fontSize: "14px"
            }}
            label="Scheduled" />
        },
        {
          name: "Date Scheduled",
          selector: row => row?.createdAt && dayjs(row?.deliveryOptions?.notification?.scheduledTime).format('MMMM D, h:mm A [GMT]Z'),
          grow: 2
        },
        {
          name: "Recipients",
          selector: row => row.recipientsStatus?.length,
        },
        {
          name: "Open Count",
          selector: row => row?.openedCount,
        },
        {
          name: "Open Rate",
          selector: row => {
            const openedRate = Math.floor(row?.openedCount / row?.recipientsStatus?.length) * 100;
            return (
              <div className={styles.openRate}>
                <p>{openedRate}% Opened</p>
                <ProgressBar percentage={openedRate} />
              </div>
            )
          }
        },
        ...(!permissionsDenied[getUserAccess()]?.includes("deleteScheduledAnnouncement") ?
          [{
            name: "Action",
            selector: row => <Delete_Icon onClick={(e) => handleDeleteIcon(e, row)} className={styles.optionsIcon} />
          }] :
          []
        )
      ]
    )
  }, [])

  const handleDeleteIcon = (e, row) => {
    e.stopPropagation()
    setSelectedAnnouncement(row);
    setDeleteModalOpen(true);
  };

  const onAfterEditOrDelete = () => {
    dispatch(fetchannouncementList({ limit, pageNumber, type: 'notification', notificationType: "scheduled" }))
  }

  const handlePageChange = (page) => {
    dispatch(setAnnpuncementsSchedulePagination({ limit, pageNumber: page }))
  }

  const handlePerRowsChange = (perPage) => {
    dispatch(setAnnpuncementsSchedulePagination({ limit: perPage, pageNumber: 1 }))
  };

  useEffect(() => {
    dispatch(fetchannouncementList({ limit, pageNumber, type: 'notification', notificationType: "scheduled" }))
    return () => {
      dispatch(clearAnnouncements())

    }
  }, [limit, pageNumber]);

  return (
    <>
      {
        status === "fetched" && !announcements.length ?

          <div className={styles.ScheduledNoDataContainer}>
            <div className={styles.leftContainer}>
              <img src={ScheduledTabImg} alt="Scheduled Tab" />
            </div>
            <div className={styles.rightConatiner}>
              <h3>You currently have no scheeduled announcements.</h3>
              <p>Scheduled an announcement to broadcast important news, information, and updates to your organisation</p>
              <Button
                className={styles.createAnnouncement}
                label="Create"
                onClick={() => {
                  navigate("/announcements/create")
                }}
              >
                <span style={{ fontSize: "15px" }}>SCHEDULED ANNOUNNCEMENT</span>
              </Button>
            </div>
          </div>
          :
          <div className={styles.ScheduledTabContainer}>
            <div className={styles.dataContainer}>
              <NewTable
                columns={column}
                data={announcements}
                onRowClicked={
                  (row) => {
                    navigate(`/announcements/${row?._id}`, { state: { type: "scheduled" } })
                  }
                }
                progressPending={status === "loading"}
                paginationTotalRows={totalCount}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                pagination
                paginationServer
              />
            </div>
          </div>
      }
      <DeleteModal
        modalOpen={deleteModalOpen}
        setModalOpen={setDeleteModalOpen}
        getData={onAfterEditOrDelete}
        selected={selectedAnnouncement}
        setSelected={setSelectedAnnouncement}
        heading={"Announcemnet"}
        endPoint={ANNOUNCEMENT}
      />
    </>
  );
}

export default ScheduledTab;

